import clsx from "clsx"

import { RoomDirection } from "../../../lib/types"
import { MaskStyleVariant, maskColorStyleVariant } from "../../../styles/mask.css"

import { bracketStyle, containerStyle, textStyle } from "./timetableRoomTimeAtLocation.css"

interface Props {
  time: string
  roomName: string
  roomDirection: RoomDirection
  maskVariant: MaskStyleVariant
}

export default function TimetableRoomTimeAtLocation({
  time,
  roomName,
  roomDirection,
  maskVariant,
}: Props) {
  const rotation = {
    UpLeft: -135,
    Up: -90,
    UpRight: -45,
    Right: 0,
    DownRight: 45,
    Down: 90,
    DownLeft: 135,
    Left: 180,
  } satisfies Record<RoomDirection, number>

  return (
    <div className={containerStyle}>
      <h3 className={textStyle}>
        <span className={clsx(bracketStyle, maskColorStyleVariant[maskVariant])}>( </span>
        {time}
        <span className={clsx(bracketStyle, maskColorStyleVariant[maskVariant])}> ) @ </span>
        {roomName}
      </h3>
      <div
        style={{
          transform: `rotate(${rotation[roomDirection]}deg)`,
        }}>
        <svg
          style={{ width: "calc(28 * var(--u))" }}
          viewBox="0 0 40 40"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M21.6312374,2 L39,19.5000627 L21.6312374,37 L18,33.3418362 L29.26,22 L1,22 L1,17 L29.26,17 L18,5.65816376 L21.6312374,2 Z"
            fill="white"
            fillRule="nonzero"
          />
        </svg>
      </div>
    </div>
  )
}
